<template>
  <div class="vgnes-entrance-monitor">
    <section class="wayfinder-section">
      <div class="building-stage">
        <img class="vgnes-logo" src="../vgBadNeustadtOutdoorMonitor/logo-vgem-bad-neustadt.svg" alt="">
        <img class="building-graphic" src="./icons/gebaeudeansicht.svg" alt="Wegweiser Verwaltungsgemeinschaft Bad Neustadt">
      </div>
    </section>

    <section class="content-section">
      <article class="content-panel news-panel">
        <header>
          <div>
            <p>Neuigkeiten</p>
            <div class="news-date" v-if="backendNews.date">{{ backendNews.date }}</div>
            <h2>{{ backendNews.title }}</h2>
            <h3 v-if="backendNews.subtitle">{{ backendNews.subtitle }}</h3>
          </div>
        </header>
        <div class="backend-news-body" :class="{ 'has-image': backendNews.image }">
          <div class="backend-news-image-frame" v-if="backendNews.image">
            <img :src="backendNews.image" alt="">
          </div>
          <div class="backend-news-copy">
            <div class="backend-news-text-viewport" :class="{ 'has-next-page': backendNewsHasNextPage }" ref="backendNewsTextViewport">
              <div
                  class="backend-news-text-scroller rich-text"
                  ref="backendNewsTextScroller"
                  :style="{ transform: 'translateY(-' + backendNewsOffset + 'px)' }"
                  v-html="backendNews.text"
              ></div>
            </div>
          </div>
        </div>
      </article>

      <article class="content-panel information-panel">
        <header>
          <div>
<!--            <p>Informationen</p>-->
            <h2>{{ currentInformation.title }}</h2>
            <div class="info-date" v-if="currentInformation.date">{{ currentInformation.date }}</div>
            <h3 v-if="currentInformation.subtitle">{{ currentInformation.subtitle }}</h3>
          </div>
        </header>
        <div class="information-body" :class="{ 'has-image': currentInformation.image }">
          <div class="information-image-frame" v-if="currentInformation.image">
            <img :src="currentInformation.image" alt="" @load="recalculateInformationPages">
          </div>
          <div class="information-copy">
            <div class="info-text-viewport" ref="infoTextViewport">
              <div
                  class="info-text-scroller rich-text"
                  ref="infoTextScroller"
                  :style="{ transform: 'translateY(-' + currentInformationOffset + 'px)' }"
                  v-html="currentInformation.text"
              ></div>
            </div>
          </div>
        </div>
        <div class="information-progress" v-if="informationSlides.length > 1 || informationPageOffsets.length > 1">
          <span
              v-for="(item, index) in informationSlides"
              :key="item.title + index"
              :class="{ active: index === currentInformationIndex }"
          ></span>
        </div>
      </article>

      <article class="content-panel room-panel">
        <header>
          <div>
            <p>Raumbelegung</p>
<!--            <h2>{{ roomHeadline }}</h2>-->
          </div>
        </header>
        <div class="room-bookings-text rich-text" v-if="roomBookingsHtml" v-html="roomBookingsHtml"></div>
        <template v-else>
          <div v-for="booking in roomBookings" :key="booking.title + booking.time" class="booking-card">
            <h3>{{ booking.title }}</h3>
            <div class="booking-infos">
              <p class="booking-room" v-if="booking.room">
                <img class="booking-info-icon pin-icon" src="./icons/pin.svg" alt="">
                <span>{{ booking.room }}</span>
              </p>
              <p class="booking-time">
                <img class="booking-info-icon clock-icon" src="./icons/uhr.svg" alt="">
                <span>{{ booking.time }}</span>
              </p>
            </div>
          </div>
        </template>
      </article>
    </section>

    <footer class="job-ticker" aria-label="Stellenausschreibungen" v-if="jobTickerText">
      <div class="ticker-track">
        <span>{{ jobTickerText }}</span>
        <span>{{ jobTickerText }}</span>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";

const INFORMATION_NEWS_UUID = '9ae08978-f649-4686-8b90-48ce6a0888bd'
const INFORMATION_NEWS_URL = `https://aht1gh-api.sqronline.de/api/modules/news/getnews?module_division_uuid=${INFORMATION_NEWS_UUID}&newsTextAsHtml=true`
const JOBS_URL = 'https://www.bad-neustadt-vgem.de/stellenausschreibungen'
const SLIDE_INTERVAL_MS = 10000

export default {
  name: "VgBadNeustadtEntranceMonitor",
  data () {
    return {
      informationNews: [],
      currentInformationIndex: 0,
      currentInformationPage: 0,
      informationPageOffsets: [0],
      backendNewsPage: 0,
      backendNewsPageOffsets: [0],
      homepageJobs: [],
      informationInterval: null,
      resizeHandler: null
    }
  },
  computed: {
    ...mapGetters({
      getCurrentViewContent: 'getCurrentViewContent',
      getCurrentViewFiles: 'getCurrentViewFiles'
    }),
    content () {
      return this.getCurrentViewContent || {}
    },
    backendNews () {
      let withoutBackendNewsFallback = true // bei nicht gesetzten Backend-news soll kein Fallback zurückgegeben werden
      if (withoutBackendNewsFallback || this.content.entrance_news_title || this.content.entrance_news_text || this.content.entrance_news_subline || this.content.entrance_news_date) {
        // Diese Felder entsprechen dem aktuellen Backend-Schema fuer ViewType 12.
        return {
          title: this.content.entrance_news_title || 'Neuigkeit VG Bad Neustadt',
          subtitle: this.content.entrance_news_subline || '',
          text: this.content.entrance_news_text || '',
          date: this.formatDate(this.content.entrance_news_date),
          image: this.resolveContentImage(this.content.entrance_news_image) || this.currentViewFileUrl
        }
      }

      const rows = this.normalizeContentItems(this.content.entrance_news || this.content.entranceNews || this.content.news)

      if (rows.length > 0) {
        return rows[0]
      }

      if (this.content.news_title || this.content.headline_news) {
        return {
          title: this.content.news_title || this.content.headline_news,
          subtitle: this.content.news_subtitle || this.content.news_subline || this.content.subtitle_news,
          text: this.content.news_text || this.content.text_news || '',
          date: this.formatDate(this.content.news_date || this.content.date_news),
          image: this.resolveContentImage(this.content.news_image || this.content.news_image_url) || this.currentViewFileUrl
        }
      }

      // Fallback nach Freigabe-PDF, damit das Layout auch ohne gepflegten Backend-Inhalt bewertbar bleibt.
      return {
        title: 'Öffnungszeiten VG Geschäftsstelle und Wahlamt',
        subtitle: 'Rosenmontag und Faschingsdienstag',
        text: 'Am Rosenmontag und Faschingsdienstag gelten geänderte Öffnungszeiten. Bitte beachten Sie die aktuellen Hinweise der Verwaltungsgemeinschaft.',
        date: '28.01.2026',
        image: this.currentViewFileUrl
      }
    },
    currentViewFileUrl () {
      if (this.getCurrentViewFiles && this.getCurrentViewFiles.length > 0 && this.getCurrentViewFiles[0].url) {
        return this.getCurrentViewFiles[0].url
      }

      return ''
    },
    informationSlides () {
      return this.informationNews.length > 0 ? this.informationNews : this.fallbackInformationSlides
    },
    currentInformation () {
      return this.informationSlides[this.currentInformationIndex] || this.fallbackInformationSlides[0]
    },
    currentInformationOffset () {
      return this.informationPageOffsets[this.currentInformationPage] || 0
    },
    backendNewsOffset () {
      return this.backendNewsPageOffsets[this.backendNewsPage] || 0
    },
    backendNewsHasNextPage () {
      return this.backendNewsPage < this.backendNewsPageOffsets.length - 1
    },
    fallbackInformationSlides () {
      return [
        {
          title: 'Infotag Jugend & Beruf',
          subtitle: 'Wir sind dabei!',
          text: 'Ausbildung bei der Verwaltungsgemeinschaft Bad Neustadt a. d. Saale. Wir informieren über Aufgaben, Ausbildungswege und Einstiegsmöglichkeiten in der kommunalen Verwaltung.',
          date: 'Samstag, 21.03.2026',
          image: ''
        }
      ]
    },
    roomHeadline () {
      return this.roomBookings.length === 1 ? 'Nächster Termin' : 'Aktuelle Termine'
    },
    roomBookingsRawText () {
      return this.content.room_bookings_text || this.content.roomBookingsText || this.content.room_occupancy_text || ''
    },
    roomBookingsHtml () {
      if (typeof this.roomBookingsRawText !== 'string' || !this.roomBookingsRawText.trim() || this.isStructuredRoomBookingText(this.roomBookingsRawText)) {
        return ''
      }

      // Alternativ gepflegte CKEditor-Texte sollen unveraendert als Hinweistext ausgegeben werden.
      return this.roomBookingsRawText
    },
    roomBookings () {
      const rows = this.normalizeBookings(this.content.room_bookings || this.content.roomBookings || this.content.room_occupancy)

      if (rows.length > 0) {
        return rows
      }

      const textRows = this.parseBookingText(this.roomBookingsRawText)

      if (textRows.length > 0) {
        return textRows
      }

      // Bis zur Outlook-Anbindung kann die Raumbelegung komplett aus dem indisigno-Backend gepflegt werden.
      return [
        {
          title: 'Titel der Besprechung',
          room: 'Besprechungsraum Bauverwaltung, Zimmer 110',
          time: 'Mittwoch, 28. Januar 2026 von 09:15 bis 11:15 Uhr'
        },
        {
          title: 'Hier steht der Titel der Besprechung',
          room: 'Besprechungsraum Bauverwaltung, Zimmer 110',
          time: 'Mittwoch, 28. Januar 2026 von 13:15 bis 14:15 Uhr'
        }
      ]
    },
    jobTickerItems () {
      const backendText = this.content.jobs_ticker_text || this.content.jobsTickerText || this.content.job_ticker || this.content.jobs

      if (typeof backendText === 'string' && backendText.trim()) {
        return this.splitTickerText(backendText)
      }

      if (Array.isArray(backendText)) {
        return backendText.map(item => this.cleanText(item.title || item.name || item.text || item)).filter(Boolean)
      }

      return []
    },
    jobTickerText () {
      if (this.jobTickerItems.length === 0) {
        return ''
      }

      return `${this.jobTickerItems.join(' --- ')} --- `
    }
  },
  methods: {
    async loadInformationNews () {
      try {
        const response = await axios.get(INFORMATION_NEWS_URL)
        const rows = this.normalizeSqronlineNews(response.data && response.data.data)

        if (rows.length > 0) {
          this.informationNews = rows.slice(0, 5)
          this.currentInformationIndex = 0
          this.currentInformationPage = 0
          this.recalculateInformationPages()
        }
      } catch (error) {
        // Bei Netzwerk-/CORS-Problemen bleibt die Folie mit Backend- oder Fallbackdaten stabil sichtbar.
        console.warn('VG NES Informationen konnten nicht von sqronline geladen werden.', error)
      }
    },
    async loadHomepageJobs () {
      try {
        const response = await axios.get(JOBS_URL)
        const rows = this.parseHomepageJobs(response.data)

        if (rows.length > 0) {
          this.homepageJobs = rows
        }
      } catch (error) {
        // Die Stellen kommen bevorzugt aus dem Backend; Homepage-Scraping ist nur ein optionaler Fallback.
        console.warn('VG NES Stellenausschreibungen konnten nicht von der Homepage geladen werden.', error)
      }
    },
    normalizeSqronlineNews (value) {
      if (!Array.isArray(value)) {
        return []
      }

      return value
          .map(item => ({
            title: this.cleanText(item.news_title || item.title),
            subtitle: this.cleanText(item.news_subtitle || item.subtitle),
            text: item.news_text || item.text || '',
            date: this.formatDate(item.news_date || item.news_datetime || item.created_at),
            image: this.getSqronlineImageUrl(item)
          }))
          .filter(item => item.title || item.text)
    },
    normalizeContentItems (value) {
      if (!Array.isArray(value)) {
        return []
      }

      return value
          .map(item => ({
            title: this.cleanText(item.title || item.news_title || item.headline),
            subtitle: this.cleanText(item.subtitle || item.news_subtitle || item.news_subline || item.subline),
            text: item.text || item.news_text || item.body || '',
            date: this.formatDate(item.date || item.news_date || item.datetime),
            image: this.resolveContentImage(item.image || item.image_url || item.url)
          }))
          .filter(item => item.title || item.text)
    },
    normalizeBookings (value) {
      if (!Array.isArray(value)) {
        return []
      }

      return value
          .map(item => ({
            title: this.cleanText(item.title || item.subject || item.name),
            room: this.cleanText(item.room || item.location),
            time: this.cleanText(item.time || item.date || item.datetime)
          }))
          .filter(item => item.title && item.time)
    },
    parseBookingText (value) {
      if (typeof value !== 'string') {
        return []
      }

      if (/<[a-z][\s\S]*>/i.test(value)) {
        if (!this.isStructuredRoomBookingText(value)) {
          return []
        }

        const wrapper = document.createElement('div')
        wrapper.innerHTML = value

        // Im CKEditor bildet jede Liste einen Termin; die Listeneintraege entsprechen Titel, Raum und Zeit.
        const listRows = Array.from(wrapper.querySelectorAll('ul, ol'))
            .map((list, index) => {
              const lines = Array.from(list.querySelectorAll('li'))
                  .map(item => this.cleanText(item.textContent))
                  .filter(Boolean)

              return {
                title: lines[0] || `Termin ${index + 1}`,
                room: lines[1] || '',
                time: lines.slice(2).join(' ')
              }
            })
            .filter(item => item.title && item.time)

        if (listRows.length > 0) {
          return listRows
        }
      }

      return value
          .split(/\n\s*\n/)
          .map((block, index) => {
            const lines = block.split('\n').map(line => line.trim()).filter(Boolean)
            return {
              title: lines[0] || `Termin ${index + 1}`,
              room: lines[1] || '',
              time: lines.slice(2).join(' ')
            }
          })
          .filter(item => item.title && item.time)
    },
    isStructuredRoomBookingText (value) {
      // Nur direkt mit einer Liste beginnende CKEditor-Inhalte werden in Raumbelegungs-Karten zerlegt.
      return /^<\s*(ul|ol)\b/i.test(String(value || '').trim())
    },
    parseHomepageJobs (html) {
      if (!html || typeof DOMParser === 'undefined') {
        return []
      }

      const doc = new DOMParser().parseFromString(html, 'text/html')
      const anchors = Array.prototype.slice.call(doc.querySelectorAll('a'))
      const rows = anchors
          .map(anchor => this.cleanText(anchor.textContent))
          .filter(text => text && /(\(m\/w\/d\)|ausbildung|stellen|fachkraft|mitarbeiter|sachbearbeiter)/i.test(text))

      return Array.from(new Set(rows)).slice(0, 8)
    },
    getSqronlineImageUrl (item) {
      if (item.set_title_image && item.set_title_image[0] && item.set_title_image[0].direct_url) {
        return item.set_title_image[0].direct_url
      }

      return item.image_url || item.direct_url || ''
    },
    resolveContentImage (value) {
      if (!value) {
        return ''
      }

      if (typeof value === 'string') {
        return value
      }

      return value.url || value.direct_url || value.path || ''
    },
    splitTickerText (value) {
      const html = String(value).trim()

      if (/<[a-z][\s\S]*>/i.test(html)) {
        const wrapper = document.createElement('div')
        wrapper.innerHTML = html

        // Im CKEditor steht jede Stelle in einem eigenen Absatz; <br> innerhalb eines Absatzes bleibt Teil derselben Stelle.
        const blocks = Array.from(wrapper.querySelectorAll('p, li'))
            // .map(item => this.cleanText(item.textContent.replace(/^Wir suchen:\s*/i, '')))
            .map(item => this.cleanText(item.textContent))
            .filter(Boolean)

        if (blocks.length > 0) {
          return blocks
        }
      }

      return value
          .split(/\n|;|---/)
          // .map(item => this.cleanText(item.replace(/^Wir suchen:\s*/i, '')))
          .map(item => this.cleanText(item))
          .filter(Boolean)
    },
    cleanText (value) {
      if (value === null || value === undefined) {
        return ''
      }

      return String(value).replace(/\s+/g, ' ').trim()
    },
    formatDate (value) {
      if (!value) {
        return ''
      }

      const date = new Date(value)

      if (isNaN(date.getTime())) {
        return this.cleanText(value)
      }

      return date.toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})
    },
    advanceInformation () {
      if (this.currentInformationPage < this.informationPageOffsets.length - 1) {
        this.currentInformationPage++
        return
      }

      this.currentInformationIndex = (this.currentInformationIndex + 1) % this.informationSlides.length
      this.currentInformationPage = 0
      this.recalculateInformationPages()
    },
    advanceBackendNews () {
      if (this.backendNewsPage < this.backendNewsPageOffsets.length - 1) {
        this.backendNewsPage++
        return
      }

      this.backendNewsPage = 0
    },
    advanceContentSlides () {
      this.advanceBackendNews()
      this.advanceInformation()
    },
    recalculateBackendNewsPages () {
      this.$nextTick(() => {
        const viewport = this.$refs.backendNewsTextViewport
        const scroller = this.$refs.backendNewsTextScroller

        if (!viewport || !scroller || viewport.clientHeight <= 0) {
          this.backendNewsPageOffsets = [0]
          return
        }

        // Der Backend-News-Text nutzt die gleiche seitenweise Logik wie die Homepage-Informationen.
        const pageHeight = viewport.clientHeight
        const pageCount = Math.max(1, Math.ceil(scroller.scrollHeight / pageHeight))

        this.backendNewsPageOffsets = Array.from({length: pageCount}, (item, index) => index * pageHeight)

        if (this.backendNewsPage > this.backendNewsPageOffsets.length - 1) {
          this.backendNewsPage = 0
        }
      })
    },
    recalculateInformationPages () {
      this.$nextTick(() => {
        const viewport = this.$refs.infoTextViewport
        const scroller = this.$refs.infoTextScroller

        if (!viewport || !scroller || viewport.clientHeight <= 0) {
          this.informationPageOffsets = [0]
          return
        }

        const pageHeight = viewport.clientHeight
        const pageCount = Math.max(1, Math.ceil(scroller.scrollHeight / pageHeight))

        this.informationPageOffsets = Array.from({length: pageCount}, (item, index) => index * pageHeight)

        if (this.currentInformationPage > this.informationPageOffsets.length - 1) {
          this.currentInformationPage = 0
        }
      })
    }
  },
  watch: {
    backendNews () {
      this.backendNewsPage = 0
      this.recalculateBackendNewsPages()
    },
    currentInformation () {
      this.recalculateInformationPages()
    }
  },
  mounted () {
    this.loadInformationNews()
    // this.loadHomepageJobs() // erstmal deaktiviert, da evtl. gar nicht gefordert die Stellen von der Website zu laden (+ mögliche CORS-Probleme beim Laden über JS, welche evtl. ein Proxy-Script benötigen) -> Über indisigno gibt es ein Textfeld dafür
    this.recalculateBackendNewsPages()
    this.recalculateInformationPages()
    this.informationInterval = setInterval(this.advanceContentSlides, SLIDE_INTERVAL_MS)
    this.resizeHandler = () => {
      this.recalculateBackendNewsPages()
      this.recalculateInformationPages()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy () {
    clearInterval(this.informationInterval)
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: url('/fonts/vg_nes/Poppins-Light.ttf') format("truetype")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/vg_nes/Poppins-Regular.ttf') format("truetype")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: url('/fonts/vg_nes/Poppins-Medium.ttf') format("truetype")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: url('/fonts/vg_nes/Poppins-Bold.ttf') format("truetype")
}

.vgnes-entrance-monitor {
  --vg-blue: #155c86;
  /*--vg-blue-dark: #0c4262;*/
  --vg-blue-dark: #24527F;
  --vg-orange: #f6a51a;
  --vg-green: #6fac46;
  --vg-red: #d54332;
  --vg-panel: #f2f2f2;
  --vg-text: #111111;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: grid;
  /*grid-template-rows: 50.2vh 44.2vh 5.6vh;*/
  grid-template-rows: 47.2vh 47.2vh 5.6vh;
  color: var(--vg-text);
  background: #ffffff;
  font-family: "Poppins",sans-serif;
}

.wayfinder-section {
  position: relative;
  background: #ffffff;
}

.building-stage {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.vgnes-logo {
  position: absolute;
  top: 4.1vh;
  /*right: 4.3vw;*/
  /*width: 13.9vw;*/
  right: 2.3vw;
  width: 10.9vw;
  z-index: 2;
}

.building-graphic {
  position: absolute;
  left: 3.2vw;
  right: 3.2vw;
  bottom: 2.2vh;
  /*width: 93.6vw;*/
  width: 90.6vw;
  max-height: 41.5vh;
  object-fit: contain;
}

.content-section {
  display: grid;
  grid-template-columns: 33.25vw 33.5vw 33.25vw;
  border-top: 0.65vh solid #ffffff;
  background: #d9d9d9;
}

.content-panel {
  position: relative;
  min-width: 0;
  overflow: hidden;
  /*padding: 3.1vh 2.75vw 2.5vh;*/
  padding: 2.1vh 2vw 2.5vh;
}

.content-panel::before {
  content: "";
  position: absolute;
  /*top: 2.2vh;
  right: 1.2vw;*/
  bottom: -2.2vh;
  left: 1.2vw;
  width: 8.5vw;
  height: 15vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.22;
  pointer-events: none;
}

.content-panel header {
  position: relative;
  z-index: 1;
}

.news-panel::before {
  background-image: url('./icons/neuigkeiten.svg');
  opacity: 0.3;
}

/*.information-panel::before {
  background-image: url('./icons/zeiten.svg');
  filter: invert(29%) sepia(71%) saturate(847%) hue-rotate(165deg) brightness(84%) contrast(89%);
}*/

.room-panel::before {
  background-image: url('./icons/raumbelegung.svg');
  /*filter: invert(29%) sepia(71%) saturate(847%) hue-rotate(165deg) brightness(84%) contrast(89%);*/
  opacity:0.4;
}

.content-panel header p {
  margin: 0 0 1.1vh;
  /*font-size: 1.05vw;*/
  /*font-weight: 500;
  letter-spacing: 0.08em;*/
  /*text-transform: uppercase;*/
  font-weight: 700;
  font-size: 1.5vw;
}

.content-panel h2 {
  margin: 0;
  /*font-size: 2.05vw;*/
  font-size: 0.8vw;
  font-weight: 700;
  line-height: 1.12;
  text-transform: uppercase;
}

.content-panel h3 {
  margin: 0 0 1.15vh;
  /*font-size: 1.25vw;*/
  font-size: 0.7vw;
  /*font-weight: 700;*/
  font-weight: 400;
  line-height: 1.24;
}

.news-panel {
  background: var(--vg-blue);
  color: #ffffff;
  display: flex;
  flex-direction: column;
}

.backend-news-body {
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  /*margin-top: 2.2vh;*/
  margin-top: 0.8vh;
  overflow: hidden;
}

.backend-news-body.has-image {
  grid-template-columns: minmax(0, 42%) minmax(0, 1fr);
  /*gap: 1.55vw;*/
  gap: 1.1vw;
}

.backend-news-image-frame {
  min-width: 0;
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  /*padding-right: 1.55vw;
  border-right: 0.12vw solid rgba(255, 255, 255, 0.78);*/
  overflow: hidden;
}

.backend-news-image-frame img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.backend-news-copy {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-left: 1.1vw;
  border-left: 0.12vw solid rgba(255, 255, 255, 0.78);
}

.backend-news-text-viewport {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.backend-news-text-viewport.has-next-page::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3vh;
  background: linear-gradient(to bottom, rgba(21, 92, 134, 0), var(--vg-blue));
  pointer-events: none;
}

.backend-news-text-scroller {
  transition: transform 0.55s ease;
}

.news-date,
.info-date {
  margin: 1.6vh 0 0.8vh;
  /*font-size: 1vw;*/
  font-size: 0.7vw;
  font-weight: 700;
}

.information-panel,
.room-panel {
  background: var(--vg-panel);
}

.information-panel {
  /*border-left: 0.55vw solid #ffffff;
  border-right: 0.55vw solid #ffffff;*/
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-bottom: 1vh;
}

.content-panel.information-panel h2 {
  font-size:1.5vw;
}

.information-panel::after {
  /* Die Trennlinie bleibt oben und unten frei, damit sie nur neben dem eigentlichen Content sichtbar ist. */
  content: "";
  position: absolute;
  top: 2.1vh;
  right: 0;
  bottom: 2.1vh;
  width: 0.06vw;
  background: #ffffff;
}

.information-panel header h3 {
  font-weight:700;
  font-size:0.9vw;
}

.information-body {
  /* Fuellt den freien Platz zwischen dynamisch hoher Headline und unten fixiertem Progress. */
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.45vw;
  /*margin-top: 1.2vh;*/
  overflow: hidden;
}

.information-body.has-image {
  grid-template-columns: 42% 1fr;
}

.information-image-frame {
  min-width: 0;
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
}

.information-image-frame img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.information-copy {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.info-text-viewport {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.info-text-scroller {
  transition: transform 0.55s ease;
}

.information-progress {
  flex: 0 0 auto;
  display: flex;
  gap: 0.42vw;
  align-items: center;
  justify-content: center;
  height: 2.3vh;
  margin-top: auto;
}

.information-progress span {
  width: 0.62vw;
  height: 0.62vw;
  border-radius: 50%;
  background: #b9b9b9;
}

.information-progress span.active {
  background: var(--vg-blue);
}

.booking-card {
  margin-top: 2.3vh;
  /*padding-top: 2.2vh;*/
  /*border-top: 0.12vh solid #c7c7c7;*/
  position: relative;
  z-index: 10;
}

.booking-card:first-of-type {
  margin-top: 2vh;
}

.room-bookings-text.rich-text {
  /* Freitext aus dem CKEditor ersetzt die strukturierten Raumbelegungs-Karten, wenn keine Listenstruktur gepflegt wurde. */
  margin-top: 2vh;
  color: var(--vg-blue-dark);
  font-weight: 500;
  position: relative;
  z-index: 10;
}

.room-bookings-text.rich-text strong {
  font-weight:700;
}

.booking-card h3 {
  color: var(--vg-blue-dark);
  font-weight:700;
  font-size:1vw;
}

.booking-card .booking-infos {
  padding-left:1vw;
  border-left:0.1vw solid #307E1A;
  font-weight:700;
  font-size: 0.7vw;
}

.booking-room,
.booking-time {
  margin: 0;
  /*font-size: 1.05vw;*/
  display: grid;
  grid-template-columns: 0.62vw minmax(0, 1fr);
  gap: 0.45vw;
  align-items: center;
  line-height: 1.32;
}

/* Die Icons bilden die Vorlage nach: Ort und Uhrzeit werden als kompakte Infospalten neben dem gruenen Balken gelesen. */
.booking-info-icon {
  display: block;
  width: 0.62vw;
  height: 0.62vw;
  object-fit: contain;
}

.pin-icon {
  height: 0.7vw;
}

.rich-text {
  /*font-size: 1.02vw;*/
  font-size: 0.7vw;
  font-weight: 300;
  line-height: 1.42;
}

.rich-text >>> p {
  margin: 0 0 1vh;
}

.rich-text >>> img {
  max-width: 100%;
  height: auto;
}

.job-ticker {
  overflow: hidden;
  display: flex;
  align-items: center;
  /*border-top: 0.5vh solid #e8e8e8;*/
  background: #ffffff;
  color: var(--vg-blue-dark);
  font-size: 1.38vw;
  font-weight: 700;
  white-space: nowrap;
}

.ticker-track {
  display: flex;
  width: max-content;
  animation: vgnesEntranceTicker 42s linear infinite;
}

.ticker-track span {
  padding-right: 7vw;
}

@keyframes vgnesEntranceTicker {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}
</style>
